<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-09-05 14:06:09
 * @LastEditTime: 2020-03-12 16:49:43
 * @LastEditors: 陆伟
 -->
<template>
  <div class="schemeB">
    <!-- 云币领取 -->
    <div class="receive" v-if="cloudData.type == 0">
      <div class="scheme-top">
        <img :src="cloudData.headUrl" alt="" class="scheme-img">
        <p>来自“{{cloudData.shopName}}”的红包</p>
      </div>
      <img src="../image/scheme-btn.gif" alt="" class="scheme-btn" @click="clickCloud()">
      <img src="../image/scheme-bottom.jpg" alt="" class="scheme-bottom">
    </div>
    <!-- 云币领取结果 -->
    <div class="result"  v-if="cloudData.type == 1 || cloudData.type == 2 || cloudData.type == 3">
      <div class="info">
        <!-- 领取成功 -->
        <div v-if="cloudData.type == 1">
          <img src="../image/bg-success.jpg" alt="" class="bg">
          <img src="../image/btn-success.gif" alt="" class="bg" @click="goMore()">
          <div class="title">
            <div>恭喜你获得</div>
            <i></i>
          </div>
          <div class="account" @click="goCouponList()">
            云币已放入{{cloudData.phone}}账户 查看 >
          </div>
          <div class="box">
            <div class="left">
              <div class="num">{{cloudData.couponValue}}</div>
              <div>云币</div>
            </div>
            <div class="right">
              <div>1云币=1RMB，购物可直接抵扣</div>
              <div class="date">有效期至：{{cloudData.endTime | formatNew}}</div>
            </div>
          </div>
        </div>
        <!-- 领取失败 -->
        <div v-if="cloudData.type == 2">
          <img src="../image/bg-error.jpg" alt="" class="bg">
          <img src="../image/btn-error.gif" alt="" class="bg" @click="goMore()">
          <img src="../image/error-icon.png" alt="" class="error-icon">
          <div class="error-test">手慢了，云币已抢完</div>
        </div>
        <div v-if="cloudData.type == 3" class="invalid">
          <img src="../image/bg-error.jpg" alt="" class="bg">
          <img src="../image/btn-error.gif" alt="" class="bg" @click="goMore()">
          <div>来晚了，云币已失效</div>
        </div>
      </div>
      <div class="tabs">
        <div :class="{tab: true,select: select}" @click="showShopInfo(true)">
          <img src="../image/recommend.png" alt="">
          <span>为你推荐</span>
          <i></i>
        </div>
        <div :class="{tab: true,select: !select}" @click="showShopInfo(false)">
          <span>浏览记录</span>
          <i></i>
        </div>
      </div>
      <!-- 为你推荐商品列表 -->
      <ul 
        class="shop-list ui-rows-wrap ui-rows-justify cloud-shop-20 shopInfo" 
        v-show="select"
        v-infinite-scroll="getPersonalItemByCoin"
        infinite-scroll-disabled="shopInfoLoading"
        infinite-scroll-distance="10"
      >
          <li v-for="(item, index) in shopInfo" :key="index" @click="goDetail(item,index)">
            <commodities-list ref="CommoditiesList" :item="item" :index="index"></commodities-list>
          </li>
      </ul>
      
      <!-- 浏览记录 -->
      <ul 
        class="shop-list ui-rows-wrap ui-rows-justify cloud-shop-20" 
        v-show="!select && browseRecord.length"
        v-infinite-scroll="listFootPrint"
        infinite-scroll-disabled="browseRecordLoading"
        infinite-scroll-distance="10"
      >
          <li v-for="(item, index) in browseRecord" :key="index" @click="goDetail(item,index)">
            <commodities-list ref="CommoditiesList" :item="item" :index="index"></commodities-list>
          </li>
      </ul>
      <!-- 没有浏览记录 -->
      <div v-if="!select && !browseRecord.length && !browseRecordLoading" class="browseRecord">
        <img src="../image/browseRecord.png" alt="">
        <div>
          你还没有浏览记录哦~
        </div>
      </div>
      <div class="pagebottom">
        <div v-if="(shopInfoLoading&&select) || (browseRecordLoading&&!select)">加载中...</div>
        <div v-if="(shopInfoIsLastPage&&select) || (browseRecordIsLastPage&&!select && browseRecord.length > 0)">没有更多了</div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import { Toast } from 'mint-ui'
import CommoditiesList from '@/pages/commodity/components/CommoditiesList'
import YunJi from '@/assets/js/YunJi'
import * as Http from '@/pages/commodity/api/share'
import * as yunjiysHttp from '@/pages/commodity/api/commodityList'
import * as Util from '@/assets/js/Util'
import * as Mark from '@/pages/commodity/api/itemMark'
import { InfiniteScroll } from 'mint-ui';

Vue.use(InfiniteScroll);

export default {
  name: 'scheme-receive-b',
  data() {
    return {
      select: true,
      pageIndex: 0,
      pageSize: 20,
      seqId: YunJi.getUrlParams('seqId') || '',
      shareConsumerId: YunJi.getUrlParams('shareConsumerId') || '',
      appCont: YunJi.getUrlParams('appCont') || 0,
      shopId: YunJi.getUrlParams('shopId'), // 获取店铺id,
      shopInfo: [], // 商品列表
      markedBuyAttachItemList: [], // 打标买赠商品列表
      browseRecord: [], // 浏览记录
      vComit: true,
      shopItemIds: '', // 商品id
      browseRecordIds: '', // 浏览记录id
      cursorIndex: 0,
      pageSizes: 20,
      shopInfoIsLastPage: false, // 推荐商品最后一页
      shopInfoLoading: false,
      browseRecordIsLastPage:false,
      browseRecordLoading: false

    }
  },
  filters: {
    formatNew(value) {
      return YunJi.formatNew(value, "yyyy.MM.dd");
    }
  },
  props: {
    personalItem: { // 包含商品id
      type: Object,
      default() {
        return {}
      }
    },
    cloudData: { // 基本信息
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: { 
    CommoditiesList
  },
  activated() {},
  mounted() {
    this.shopItemIds = this.personalItem.itemId
    this.getSingleDetail()
    this.listFootPrint()
  },
  methods: {
    // 点击领取云币
    clickCloud() {
      if (!this.vComit) return
      this.vComit = false // 防止重复提交
      const params = {
        seqId: this.seqId,
        shopId: this.shopId,
        shareConsumerId: this.shareConsumerId,
        appCont: this.appCont
      }
      Http.getClickCouponShare(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
          this.cloudData = res.data
        } else if(res.errorCode == 1000) {
          this.vComit = true
          this.$emit('showRegister')
        } else {
          Toast(res.errorMessage)
          this.vComit = true
        }
      }).catch(() => {
        this.vComit = true
        Toast('网络错误')
      })
    },
    // 获取推荐商品id
    getPersonalItemByCoin() {
      if (this.shopInfoIsLastPage || !this.select) {
        return
      }
      this.shopInfoLoading = true
      const params = {
        shopId: this.shopId,
        pageIndex: ++this.pageIndex,
        pageSize: this.pageSize,
        consumerId: this.cloudData.consumerId,
        coinAmount: this.cloudData.couponMoney,
      }
      Http.getPersonalItemByCoin(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          if (!res.data.itemId) {
            this.shopInfoIsLastPage = true
            this.shopInfoLoading = false
            return
          }
          this.shopItemIds = res.data.itemId
          this.getSingleDetail()
        }
      })
    },
    // 根据id获取推荐商品信息
    getSingleDetail() {
      const prams = {
        itemIdStr: this.shopItemIds
      }
      Http.getBatchItemByIds(prams).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          this.shopInfoLoading = false
          res.data.forEach((list) => {
            this.shopInfo.push(list)
          })
          this.getItemMark(this.shopItemIds, this.shopInfo)
        }
      })
    },
    // 获取浏览记录商品
    listFootPrint() {
      if (this.browseRecordIsLastPage||this.select) {
        return
      }
      this.browseRecordLoading = true
      yunjiysHttp.listFootPrint({
        appCont: this.appCont,
        cursor: this.cursorIndex++ * this.pageSizes,
        pageSize: this.pageSizes,
      }).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
          let groupList = res.data.groupList||[]
          if(!groupList.length){
            this.browseRecordIsLastPage = true
          }
          let recordList = []
          groupList.forEach((item) => {
            recordList = recordList.concat(item.recordList)
          })
          let browseRecordIds = ''
          recordList.forEach(item => {
            browseRecordIds += `,${item.itemId}`
          })
          this.browseRecord = this.browseRecord.concat(recordList)
          this.getItemMark(browseRecordIds.slice(1), this.browseRecord)
          this.browseRecordLoading = false
        } else {
          Toast(res.errorMessage)
        }
      }).catch(() => {
        Toast('网络错误')
      })
    },
    // 加载商品标
    getItemMark(ids, itemList) {
      const itemIds = {
        appCont: this.appCont,
        strVersion: '1',
        itemIds: ids,
        businessMarkType: '1'
      }
      Mark.getItemMark(itemIds).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
          let markList = res.data || []
          // 动态在商品列表里面创建 字段 markFlag
          for (let i = 0; i < itemList.length; i += 1) {
            for (let j = 0; j < markList.length; j += 1) {
              if (itemList[i].itemId === markList[j].itemId) {
                Vue.set(itemList[i], 'markFlag', markList[j].mark)
                Vue.set(itemList[i], 'markDescribe', markList[j].markDescribe)
              }
            }
          }
          this.isMorePage = false
        }
      })
    },
    /**
     * 跳转至对应的商品详情
     * @param item 商品对象
     * @param index 商品位置
     */
    goDetail(item, index) {
      // 埋点
      window.thinkingReport.track('click_list', {
        page_id: '00065',
        point_id: '21553',
        ABtestId: this.personalItem.aBtestId,
        item_id: item.itemId,
        tab_name: this.select ? '为你推荐' : '浏览记录',
        business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
        index: index + 1
      })
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/detail?itemId=${item.itemId}&appCont=0&shopId=${this.shopId}`
    },
    showShopInfo(type) {
      // 埋点
      window.thinkingReport.track('click_list', {
        page_id: '00065',
        point_id: '21551',
        ABtestId: this.personalItem.aBtestId,
        tab_name: type ? '为你推荐' : '浏览记录',
        business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
      })
      if (type) {
        this.select = true
      } else {
        this.select = false
        this.browseRecord = []
        this.browseRecordIsLastPage = false
        this.cursorIndex = 0
        this.listFootPrint()
      }
    },
    // 跳首页
    goMore() {
      // 埋点
      window.thinkingReport.track('others', {
        page_id: '00065',
        point_id: this.cloudData.type === 1 ? '21548' : '21550',
        ABtestId: this.personalItem.aBtestId,
        business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
      })
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/more?shopId=${this.shopId}&appCont=0`
    },
    // 跳云币列表
    goCouponList() {
      // 埋点
      window.thinkingReport.track('others', {
        page_id: '00065',
        point_id: '21547',
        ABtestId: this.personalItem.aBtestId,
        business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
      })
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/coupon-list?shopId=${this.shopId}&appCont=0`
    }
  }
}
</script>

<style lang="less" scoped>
  .schemeB {
    min-height: 100vh;
    background: #FFF3F4;
    .receive{
      box-sizing: border-box;
      position: absolute;
      z-index: 3;
      top: 0;
      left: 0;
      margin: 0 auto;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      text-align: center;
      .scheme-top {
        width: 1005;
        height: 4.14rem;
        background: url('../image/scheme-top.jpg') no-repeat; 
        background-size: 100% 100%;
        .scheme-img {
          margin-top: .5rem;
          width: 1.16rem;
          height: 1.16rem;
          border-radius: 50%;
          border: .06rem solid #fff;
        }
        p{
          font-size: 0.3rem;
          color: #FFFFFF;
          margin-top: 0.2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .scheme-btn,.scheme-bottom{
        width: 100%;
        vertical-align: top;
      }
      
    }
    .result{
      padding-bottom: 0.4rem;
      .info{
        position: relative;
        height: 7rem;
        .bg{
          width: 100%;
          vertical-align: top;
        }
        .title{
          position: absolute;
          top: 1.1rem;
          left: 0;
          width: 100%;
          height: 0.6rem;
          i{
            display: inline-block;
            width: 2.46rem;
            height: 0.24rem;
            background: #FFEC6C;
            border-radius: 0.12rem;
            position: absolute;
            bottom: 0.12rem;
            left: 50%;
            transform: translate(-50%,0);
          }
          div{
            font-size: 0.44rem;
            color: #FF0015;
            font-weight: bold;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,0);
            z-index: 1;
          }
        }
        .account{
          font-size: 0.22rem;
          color: #DAAA61;
          position: absolute;
          top: 1.85rem;
          left: 0;
          width: 100%;
          text-align: center;
        }
        .box{
          width: 5.72rem;
          height: 1.49rem;
          background: #FFF0DA;
          border: 1px solid #FFEAC8;
          box-shadow: 0 1px 0 0 #FFF8ED;
          border-radius: 0.16rem;
          position: absolute;
          top: 2.43rem;
          left: 50%;
          transform: translate(-50%,0);
          display: flex;
          .left{
            width: 1.8rem;
            text-align: center;
            color: #DAAA61;
            font-size: 0.3rem;
            .num{
              font-size: 0.5rem;
              margin: 0.32rem 0 0.2rem;
            }
          }
          .right{
            flex: 1;
            font-size: 0.22rem;
            color: #333333;
            padding-top: 0.32rem;
            .date{
              color: #92918D;
              margin-top: 0.16rem;
            }
          }
        }
        .error-icon{
          position: absolute;
          top: 1.1rem;
          left: 50%;
          transform: translate(-50%,0);
          width: 1.8rem;
        }
        .error-test{
          position: absolute;
          top: 3.25rem;
          left: 0;
          font-size: 0.42rem;
          color: #FF0015;
          width: 100%;
          text-align: center;
          font-weight: bold;
        }
        .invalid{
          div{
            position: absolute;
            top: 2.1rem;
            left: 50%;
            transform: translate(-50%,0);
            width: 5.72rem;
            height: 1.49rem;
            background: #FFF0DA;
            font-size: 21px;
            color: #DAAA61;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          }
        }
      }
      .tabs{
        display: flex;
        background: #fff;
        width: 7.02rem;
        height: 0.94rem;
        margin: 0 0.24rem;
        border-radius: 0.47rem;
        box-shadow: 0 2px 5px 0 #FEECED;
        .tab{
          position: relative;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.32rem;
          color: #333333;
          img{
            width: 0.36rem;
            margin-right: 0.1rem;
            vertical-align: middle;
          }
          &.select{
            color: #EC0013;
            span{
              font-weight: bold;
            }
            i{
              width: 0.5rem;
              height: 0.06rem;
              background: #EC0013;
              border-radius: 0.03rem;
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translate(-50%,0)
            }
          }
        }
      }
    }
    .shopInfo{
      min-height: 500px;
    }
    .browseRecord{
      text-align: center;
      padding: 0.7rem 0 2.7rem;
      img{
        width: 2.4rem;
      }
      div{
        font-size: 16px;
        color: #777777;
        margin-top: 0.24rem;
      }
    }
    .pagebottom{
      text-align: center;
      margin: 0.2rem 0;
    }
  }
</style>
